var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgChevronUpCircle = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#004F71"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.31408 14.7335C6.113 14.5633 6 14.3321 6 14.0911C6 13.8501 6.113 13.619 6.31408 13.4487L11.2429 9.26652C11.6617 8.91116 12.3382 8.91116 12.757 9.26652L17.6859 13.4487C18.1047 13.8041 18.1047 14.3781 17.6859 14.7335C17.2671 15.0888 16.5906 15.0888 16.1718 14.7335L11.9946 11.1982L7.82817 14.7335C7.40938 15.0888 6.72213 15.0797 6.31408 14.7335Z",
  fill: "white"
})));
export default SvgChevronUpCircle;